import React from 'react';
import { Breadcrumb, Panel, Grid, Row, Col } from 'rsuite';
import FloorCard from './FloorCard';

const WorkSpacesPage = () => {
  const floors = [
    { id: 1, name: 'Parking -1', totalSpaces: 30, availableSpaces: 15 },
    { id: 2, name: 'Ground Floor', totalSpaces: 40, availableSpaces: 22 },
    { id: 3, name: 'First Floor', totalSpaces: 35, availableSpaces: 18 }
    // Add more floors as needed
  ];

  return (
    <Panel
      header={
        <>
          <h3 className="title">Work Spaces</h3>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Flex Office</Breadcrumb.Item>
            <Breadcrumb.Item active>Work Spaces</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <Grid fluid>
        <Row gutter={16}>
          {floors.map(floor => (
            <Col key={floor.id} xs={24} sm={12} md={8} lg={6}>
              <FloorCard floor={floor} />
            </Col>
          ))}
        </Row>
      </Grid>
    </Panel>
  );
};

export default WorkSpacesPage;
